export default __webpack_public_path__ + "static/media/metamask.f8f878c1.svg";